import React from 'react';
import Logo from '../assets/Oneceptron_Logo_SVG_v3.svg';
import Typography from '@mui/material/Typography';

const Footer = () => {
    return (
        <div style ={{background: '#363740'}} align="center" color="white" >
            <Typography variant="h7" component="div" sx={{ flexGrow: 1 }} color="white">
                
            </Typography> 
           <Typography variant="h7" component="div" sx={{ flexGrow: 1 }} color="white">
                     © 2021 Swaraj Ray | <img src={Logo} alt="Logo" width="92" height="20" align="center"/>
            </Typography> 
            <Typography variant="h7" component="div" sx={{ flexGrow: 1 }} color="white">
            All rights reserved.
            </Typography>
            <Typography variant="h7" component="div" sx={{ flexGrow: 1 }} color="white">
            
            </Typography> 
        </div>
    );
}

export default Footer;